// extracted by mini-css-extract-plugin
module.exports = {"contacts-list":"style_contacts-list__1o7GN"};